import React from 'react';

type SkillCardProps = {
  children: React.ReactNode;
  title?: string;
  className?: string;
  description?: React.ReactNode | string;
};

export const SkillCard = ({
  children,
  className,
  title,
  description,
}: SkillCardProps) => {
  return (
    <div className={className}>
      <div className="text-lg font-bold mb-1">{title}</div>
      <p className="text-sm text-neutral-600 mb-2">{description}</p>
      {children}
    </div>
  );
};
